var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgToBottomArrow = function SvgToBottomArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.895 11.84a.49.49 0 0 0 .724 0l4.253-4.253c.213-.213.213-.553 0-.723l-.85-.85c-.17-.214-.511-.214-.724 0L9.3 8.181V.51A.517.517 0 0 0 8.79 0H7.768a.491.491 0 0 0-.51.51v7.672L5.215 6.013c-.213-.213-.553-.213-.723 0l-.851.85c-.213.171-.213.511 0 .724l4.253 4.254zM.724 13.96a.467.467 0 0 0-.466.467v1.106c0 .258.209.467.466.467h15.067a.467.467 0 0 0 .467-.467v-1.106a.467.467 0 0 0-.467-.467H.724z",
    fill: "#004152"
  })));
};

export default SvgToBottomArrow;